//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { HighlightLayoutPage } from './models/HighlightLayoutPage';
import type { MyHighlightLayoutsResponse } from './models/MyHighlightLayoutsResponse';
import { Utilities } from './Utilities';

export class HighlightLayoutsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getHighlightLayoutForMe: (
			page?: HighlightLayoutPage,
			categoryKey?: string,
			language?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/highlight-layouts/me?';
            if (page === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('page'));
            } else if (page !== undefined) {
                clientRequestUrl += `page=${encodeURIComponent(String(page))}&`;
            }
            if (categoryKey === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('categoryKey'));
            } else if (categoryKey !== undefined) {
                clientRequestUrl += `categoryKey=${encodeURIComponent(String(categoryKey))}&`;
            }
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieve highlight layouts for the current user.
     * @param page (optional) The page of highlight layouts to retrieve.
     * @param categoryKey (optional) The category key for filtering layouts.
     * @param language (optional) The language of the layouts. Defaults to "EN".
     * @return OK
     */
    async getHighlightLayoutForMe(
        page?: HighlightLayoutPage,
        categoryKey?: string,
        language?: string,
    ): Promise<MyHighlightLayoutsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getHighlightLayoutForMe(
            page,
            categoryKey,
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<MyHighlightLayoutsResponse>(_response, false, ['publicationDateUtc']);
    }
}
